import { useNavigate } from 'react-router-dom';
import { courses } from '../../../mocks/courses';

export default function HeroSection() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative min-h-screen pt-20 md:pt-24 pb-8 md:pb-20 bg-gradient-to-b from-[#f7f7f5] to-white overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-white/50"></div>
      
      <div className="relative max-w-6xl mx-auto px-5 md:px-12">
        <div className="text-center pt-12 md:pt-28 pb-8 md:pb-16">
          <h1 className="text-[2.2rem] leading-[1.25] sm:text-5xl md:text-7xl font-bold mb-5 md:mb-6" style={{ fontFamily: 'Noto Serif KR, serif' }}>
            <div>
              <span className="text-[#1a2332]">후니국어의 </span>
              <span className="text-[#ff6b6b]">깊이를 </span>
              <span className="text-[#1a2332]">담다</span>
            </div>
            <div className="my-3 md:my-3">
              <span className="text-[#22c55e]">&amp; </span>
              <span className="text-[#1a2332]"></span>
              <span className="text-[#3b82f6]">파주열린</span>
              <span className="text-[#1a2332]">고등부학원</span>
            </div>
          </h1>

          <p className="text-[15px] md:text-xl text-gray-600 mb-8 md:mb-10 font-light px-2 leading-relaxed">
            대입 국어의 새로운 기준을 제시합니다
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-4 px-2">
            <button
              onClick={() => scrollToSection('courses')}
              className="w-full sm:w-auto px-8 md:px-8 py-3.5 md:py-4 bg-[#1a2332] text-white text-[15px] md:text-base rounded-full hover:bg-[#ff6b6b] transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
            >
              강좌 둘러보기
              <i className="ri-arrow-right-line"></i>
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="w-full sm:w-auto px-8 md:px-8 py-3.5 md:py-4 bg-white text-[#1a2332] text-[15px] md:text-base border-2 border-[#1a2332] rounded-full hover:bg-[#1a2332] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              무료 상담 받기
            </button>
          </div>
        </div>

        {/* Desktop Hero Card */}
        <div className="hidden md:block mt-12 mb-4">
          <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl">
            <img
              src="https://static.readdy.ai/image/214ff5c1b13b1a0264073f21c7776aa4/a6361e81b74726bfab18f1adeb78eef2.png"
              alt="입시를 위한 국담 - 후니국어 열린학원"
              className="w-full h-auto object-contain"
            />
          </div>
        </div>

        {/* 후니국담 연계 블로그 카드 섹션 */}
        <div className="mt-8 md:mt-10 mb-6 md:mb-4">
          <p className="text-center text-[#ff6b6b] text-[22px] md:text-3xl font-bold tracking-wider mb-5 md:mb-6">
            후니국담 연계 블로그
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5 max-w-6xl mx-auto">
            <a
              href="https://blog.naver.com/rlgnsl98"
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 p-6 md:p-7 flex flex-col items-center justify-center text-center cursor-pointer hover:-translate-y-2 hover:scale-[1.02]"
              style={{ background: 'linear-gradient(135deg, #36d1dc 0%, #5bc0eb 30%, #7ec8e3 60%, #c3f0ca 100%)' }}
            >
              <div className="absolute inset-0 bg-white/10 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/15 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-28 h-28 bg-white/15 rounded-full translate-y-1/2 -translate-x-1/2"></div>
              <div className="absolute top-4 left-4 w-2 h-2 bg-white/50 rounded-full animate-pulse"></div>
              <div className="absolute top-8 right-8 w-1.5 h-1.5 bg-white/40 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
              <div className="absolute bottom-6 right-6 w-2.5 h-2.5 bg-white/30 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
              
              <div className="relative z-10 flex items-center gap-2 mb-2">
                <h4 className="text-[18px] md:text-[22px] font-bold text-white drop-shadow-sm whitespace-nowrap">
                  후니국담 블로그
                </h4>
                <span className="px-2 py-0.5 bg-white/30 backdrop-blur-sm text-white text-[11px] md:text-xs font-semibold rounded-full whitespace-nowrap border border-white/40">NAVER</span>
              </div>
              <p className="relative z-10 text-[13px] md:text-[14px] text-white/90 leading-relaxed mb-4">
                후니국담 최신 콘텐츠와 학습 자료
              </p>
              <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center overflow-hidden bg-white/90 shadow-lg group-hover:shadow-xl transition-shadow duration-300 group-hover:rotate-3">
                <img
                  src="https://public.readdy.ai/ai/img_res/a15041e34ce0281acff36f1e752180a1.jpg"
                  alt="네이버 블로그 로고"
                  title="후니국담 네이버 블로그"
                  className="w-12 h-12 md:w-14 md:h-14 object-contain"
                />
              </div>
              <div className="relative z-10 mt-3 flex items-center gap-1 text-white/85 group-hover:text-white text-sm font-medium transition-colors duration-300">
                <span>블로그 방문하기</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </a>

            <a
              href="https://blog.naver.com/openkosu"
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 p-6 md:p-7 flex flex-col items-center justify-center text-center cursor-pointer hover:-translate-y-2 hover:scale-[1.02]"
              style={{ background: 'linear-gradient(135deg, #0d9e4f 0%, #06c755 30%, #2dd573 60%, #a8e063 100%)' }}
            >
              <div className="absolute inset-0 bg-white/10 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute bottom-0 left-0 w-28 h-28 bg-white/10 rounded-full translate-y-1/2 -translate-x-1/2"></div>
              <div className="absolute top-4 left-4 w-2 h-2 bg-white/40 rounded-full animate-pulse"></div>
              <div className="absolute top-8 right-8 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse" style={{ animationDelay: '0.5s' }}></div>
              <div className="absolute bottom-6 right-6 w-2.5 h-2.5 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
              
              <div className="relative z-10 flex items-center gap-2 mb-2">
                <h4 className="text-[18px] md:text-[22px] font-bold text-white drop-shadow-sm whitespace-nowrap">
                  <a href="https://blog.naver.com/openkosu" target="_blank" rel="noopener nofollow">열린학원 블로그</a>
                </h4>
                <span className="px-2 py-0.5 bg-white/25 backdrop-blur-sm text-white text-[11px] md:text-xs font-semibold rounded-full whitespace-nowrap border border-white/30">NAVER</span>
              </div>
              <p className="relative z-10 text-[13px] md:text-[14px] text-white/85 leading-relaxed mb-4">
                열린학원 최신 소식과 학습 정보
              </p>
              <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center overflow-hidden bg-white/90 shadow-lg group-hover:shadow-xl transition-shadow duration-300 group-hover:rotate-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Naver%20blog%20green%20logo%20icon%20simple%20flat%20design%20on%20pure%20white%20background%20minimalist%20clean%20Korean%20social%20media%20platform%20brand%20identity%20green%20letter%20N%20symbol%20digital%20illustration%20vector%20style%20centered%20composition&width=200&height=200&seq=naver-blog-icon-1&orientation=squarish"
                  alt="네이버 블로그 로고"
                  title="열린학원 네이버 블로그"
                  className="w-12 h-12 md:w-14 md:h-14 object-contain"
                />
              </div>
              <div className="relative z-10 mt-3 flex items-center gap-1 text-white/80 group-hover:text-white text-sm font-medium transition-colors duration-300">
                <span>블로그 방문하기</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </a>

            <a
              href="https://blog.naver.com/open_dayul/224142491778"
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 p-6 md:p-7 flex flex-col items-center justify-center text-center cursor-pointer hover:-translate-y-2 hover:scale-[1.02]"
              style={{ background: 'linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 30%, #ffa07a 60%, #ffcc80 100%)' }}
            >
              <div className="absolute inset-0 bg-white/10 backdrop-blur-[2px] opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              <div className="absolute top-0 left-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 -translate-x-1/2"></div>
              <div className="absolute bottom-0 right-0 w-36 h-36 bg-white/10 rounded-full translate-y-1/2 translate-x-1/2"></div>
              <div className="absolute top-6 right-4 w-2 h-2 bg-white/40 rounded-full animate-pulse"></div>
              <div className="absolute top-10 left-6 w-1.5 h-1.5 bg-white/30 rounded-full animate-pulse" style={{ animationDelay: '0.7s' }}></div>
              <div className="absolute bottom-8 left-8 w-2.5 h-2.5 bg-white/20 rounded-full animate-pulse" style={{ animationDelay: '1.2s' }}></div>

              <div className="relative z-10 flex items-center gap-2 mb-2">
                <h4 className="text-[18px] md:text-[22px] font-bold text-white drop-shadow-sm whitespace-nowrap">
                  <a href="https://blog.naver.com/open_dayul/224142491778" target="_blank" rel="noopener nofollow">다율고 전문 블로그</a>
                </h4>
                <span className="px-2 py-0.5 bg-white/25 backdrop-blur-sm text-white text-[11px] md:text-xs font-semibold rounded-full whitespace-nowrap border border-white/30">NAVER</span>
              </div>
              <p className="relative z-10 text-[13px] md:text-[14px] text-white/85 leading-relaxed mb-4">
                다율고 맞춤 입시 전략과 분석
              </p>
              <div className="relative z-10 w-14 h-14 md:w-16 md:h-16 rounded-2xl flex items-center justify-center overflow-hidden bg-white/90 shadow-lg group-hover:shadow-xl transition-shadow duration-300 group-hover:rotate-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Naver%20blog%20green%20logo%20icon%20simple%20flat%20design%20on%20pure%20white%20background%20minimalist%20clean%20Korean%20social%20media%20platform%20brand%20identity%20green%20letter%20N%20symbol%20digital%20illustration%20vector%20style%20centered%20composition&width=200&height=200&seq=naver-blog-icon-2&orientation=squarish"
                  alt="네이버 블로그 로고"
                  title="다율고 전문 네이버 블로그"
                  className="w-12 h-12 md:w-14 md:h-14 object-contain"
                />
              </div>
              <div className="relative z-10 mt-3 flex items-center gap-1 text-white/80 group-hover:text-white text-sm font-medium transition-colors duration-300">
                <span>블로그 방문하기</span>
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </a>
          </div>
        </div>

        {/* Mobile Cards - Horizontal Scroll */}
        <div className="md:hidden mt-6 -mx-5 px-5 overflow-x-auto">
          <div className="flex gap-4 pb-4" style={{ width: 'max-content' }}>
            {courses.slice(0, 3).map((course) => (
              <div
                key={course.id}
                onClick={() => navigate(`/course/${course.id}`)}
                className="bg-white rounded-2xl shadow-lg p-5 w-72 flex-shrink-0 cursor-pointer"
              >
                {course.isPopular && (
                  <div className="inline-block px-3 py-1.5 bg-[#1a2332] text-white text-sm rounded-full mb-3">
                    인기
                  </div>
                )}
                
                <div className="w-full h-28 bg-gradient-to-br from-[#4ecdc4]/20 to-[#ff6b6b]/20 rounded-xl mb-4 flex items-center justify-center">
                  <i className="ri-book-open-line text-4xl text-[#1a2332]"></i>
                </div>

                <h3 className="text-lg md:text-xl font-bold text-[#1a2332] mb-2 text-center">
                  {course.name}
                </h3>
                <p className="text-gray-600 text-[14px] md:text-base mb-4 text-center leading-relaxed line-clamp-2">
                  {course.description}
                </p>
                <div className="text-center">
                  <span className="text-[#ff6b6b] text-base font-medium">
                    자세히 보기 →
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
